import { defaultBooleanField } from "helpers/row-logic-helper";

export const isCustom = data => {
  const isAutoProjectionCalculation = defaultBooleanField(data, "isAutoProjectionCalculation");

  return !isAutoProjectionCalculation;
};

export const isAuto = data => defaultBooleanField(data, "isAutoProjectionCalculation");
